module.exports = __webpack_public_path__ + "static/img/049_TO8_1574_og.073f288.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/049_TO8_1574_og.jpg
// module id = wX+M
// module chunks = 0